module.exports = __webpack_public_path__ + "static/media/brazil.39ce6332.png";